import React, { useEffect, useRef, useState } from 'react'

import { IMG } from '../../../themes'
import { FloorPlanLabel } from '../../../components/FloorPlanLabel'
import svgHelpers from '../../../helpers/functions/svgHelpers'

const BADGE_PX = 28
const LABEL_MIN_PX = 40
const LABEL_SPACING_PX = 8
const LABEL_MAX_PX = 160

const DeskOverlay = ({ desks, imageWidth, imageHeight, selectedId, matchedIds = [], isDeskBusy, onSelect }) => {
  const svgRef = useRef(null)
  const [renderedWidth, setRenderedWidth] = useState(0)

  useEffect(() => {
    const svg = svgRef.current
    if (!svg) return undefined
    const measure = () => setRenderedWidth(svg.getBoundingClientRect().width)
    measure()
    const observer = new ResizeObserver(measure)
    observer.observe(svg)
    return () => observer.disconnect()
  }, [])

  const scale = renderedWidth > 0 && imageWidth > 0 ? renderedWidth / imageWidth : 1

  return (
    <svg
      ref={svgRef}
      className='desk-overlay'
      viewBox={svgHelpers.getViewBox(imageWidth, imageHeight)}
      xmlns='http://www.w3.org/2000/svg'
      preserveAspectRatio='none'
    >
      {desks.map((desk) => {
        const { x, y, width } = desk.box
        const badgeSize = BADGE_PX / scale
        const labelMaxWidth = Math.min(Math.max(width * scale - LABEL_SPACING_PX, LABEL_MIN_PX), LABEL_MAX_PX)
        const isMatched = matchedIds.includes(desk.id)
        const isBusy = isDeskBusy(desk)
        const iconUrl = `url(${IMG[isBusy ? 'ic_lucide_user.svg' : 'ic_desk.svg']})`
        const label = isBusy && desk.ownerName ? desk.ownerName : desk.name
        const className = [
          'desk',
          isBusy ? 'busy' : 'available',
          desk.id === selectedId ? 'selected' : '',
        ].filter(Boolean).join(' ')

        return (
          <g key={desk.id} className={className} onClick={() => onSelect(desk)}>
            <title>{desk.name}</title>
            <polygon points={desk.coord} vectorEffect='non-scaling-stroke' />
            <foreignObject
              x={x - badgeSize / 2}
              y={y - badgeSize / 2}
              width={badgeSize}
              height={badgeSize}
            >
              <div className='desk-badge'>
                <div
                  className='desk-icon'
                  style={{
                    WebkitMaskImage: iconUrl,
                    maskImage: iconUrl,
                  }}
                />
              </div>
            </foreignObject>
            <foreignObject
              x={x}
              y={y + badgeSize / 2 + 4 / scale}
              width={1}
              height={1}
              style={{ overflow: 'visible', pointerEvents: 'none' }}
            >
              <FloorPlanLabel name={label} maxWidth={labelMaxWidth} scale={scale} />
            </foreignObject>
            {isMatched && <polygon className='desk-match-overlay' points={desk.coord} />}
          </g>
        )
      })}
    </svg>
  )
}

export default DeskOverlay
